import {
  ExperienceCategory,
  ExperienceStatus,
  ExperienceStyle,
  ExperienceSubcategory,
  ExperienceType,
} from '@ess-front/shared';
import { ConfirmationBE } from '@shared/models/confirmation-be.model';
import { StaticText } from '@shared/models/static-text.model';

export enum ExperienceEndpoint {
  BookingExperience = 'bookingexperience',
  Experience = 'experience',
  Hotel = 'hotel',
  Place = 'place',
  Restaurant = 'restaurant',
}

export enum ExperienceContentType {
  BookingExperienceModule = 'bookingexperiencemodule',
  Experience = 'experience',
  Hotel = 'hotel',
  Place = 'place',
  Villa = 'villa',
}

export interface Gallery {
  description: string | null;
  local_src: string;
  title: string | null;
}

export interface Editor {
  avatar: string | null;
  bio: string;
  email: string;
  first_name: string;
  last_name: string;
  phone: string | null;
}

export interface EditorialContent extends StaticText {
  content: string;
  id?: number;
  title: string;
}

export interface Destination {
  author?: Partial<Editor>; // do we really have it?
  description: string;
  id: number;
  title: string;
}

export interface BEAddressObject {
  address: string | null;
  city: string;
  country: string;
  full_address: string;
  phone: string | null;
  zipcode: string;
}

export interface Location {
  latitude: number;
  longitude: number;
}

export interface Detail {
  name: string;
  value: string;
}

export interface QuoteDetail {
  name: string;
  value: string;
}

export interface Confirmation {
  dates: string;
  details: Detail[];
  quote_details: QuoteDetail[];
  title: string;
}

export interface User {
  age_range: string;
  first_name: string;
  full_name: string;
  gender_title: string;
  last_name: string;
}

export interface Insider {
  description: string;
  id: number;
  image: string | null;
  title: string;
}

export interface WhatWeLove {
  content_title: string;
  image: string;
}

export interface BEExperience {
  address?: string | null;
  address_object?: BEAddressObject | null;
  arrival_datetime?: string | null;
  arrival_location?: string | null;
  arrival_title?: string | null;
  author?: Editor;
  benefits: string;
  booking_hash?: string;
  cancellation_policies?: string | null;
  category?: string;
  category_slug?: ExperienceCategory;
  city?: string;
  city_id?: number;
  confirmation?: ConfirmationBE | null;
  contact_details?: string | null;
  contact_email?: string;
  contact_phone?: string;
  content_type?: ExperienceContentType | null;
  country?: string;
  departure_title?: string;
  description?: string;
  destination?: Destination | null;
  duration?: string | null;
  editor?: Editor | null;
  editorial_content?: EditorialContent[];
  end_date?: string | null;
  from_time_display?: string | null;
  from_time_string?: string | null;
  gallery?: Gallery[];
  icon: string | null;
  id: number;
  image?: string;
  is_restaurant?: boolean;
  location: Location | null; // required
  meeting_point?: string | null;
  neighborhood?: string | null;
  notes?: string | null;
  opening_time?: string | null;
  original_experience_id?: number | null;
  phone?: string;
  price_details?: string | null;
  price_from?: string | null;
  price_range?: string | null;
  price_to?: string | null;
  quote?: string | null;
  services?: Insider[];
  slug?: string;
  start_date?: string | null;
  status?: string;
  status_slug?: ExperienceStatus;
  style?: string | null;
  style_slug?: ExperienceStyle | null;
  subcategory?: string;
  subcategory_slug?: ExperienceSubcategory;
  tag_area?: string[];
  tag_best_for?: string[];
  tag_great_for?: string[] | null;
  tag_price?: string | null;
  tag_style?: string | null;
  tag_type?: string[];
  tag_vibe?: string | null;
  tag_way?: string[] | null;
  title: string; // required
  travel_designer_notes?: string;
  type: string; // required
  type_slug: ExperienceType; // required
  user?: User | null;
  vehicle_type?: string | null;
  website?: string | null;
  what_we_love: WhatWeLove[];
  whats_included?: string;
  zipcode?: string;
}

export type ExperienceTagBE =
  | 'tag_area'
  | 'tag_best_for'
  | 'tag_great_for'
  | 'tag_price'
  | 'tag_style'
  | 'tag_type'
  | 'tag_vibe'
  | 'tag_way';
export type BEExperienceKey = keyof BEExperience;
